<template>
  <div class="intro">
    <div class="intro__headline-wrapper">
      <h1 class="intro__headline content__title" v-html="content.data.intro.header">

      </h1>
  
      <div class="intro__box">
        <div class="intro__content content__text">
          <span v-html="content.data.intro.intro"></span>
          <br />
             <img class="intro__mobbook" src="@/assets/images/booksmob.png" />
             <br />
          <div v-html="content.data.intro.content"></div>
       
          <br /><br />
          <div> <b v-html="content.data.intro.content_2"></b></div><br />
        </div>
        <div class="d-none d-lg-block text-center"></div>
        <div class="intro__counters" >

          <CounterItem  :name="content.data.intro.counters_1.text" :number="content.data.intro.counters_1.number" />
          <CounterItemAnimation :name="content.data.intro.counters_2.text"/>
          <CounterItem  :name="content.data.intro.counters_3.text" :number="content.data.intro.counters_3.number" />
        
        </div>
        
        <a href="#manifest"
          ><div class="intro__arrow pb-3">
            <img src="../../assets/images/icons/scroll.png" alt="scroll"
        />
            </div
        ></a>
      </div>
    </div>

  <img class="intro__book intro__book--right" src="../../assets/images/books.png" />
  <img class="intro__book intro__book--left" src="../../assets/images/books.png" />

  </div>
</template>

<script>
import CounterItem from "../elements/CounterItem.vue";
import CounterItemAnimation from "../elements/CounterItemAnimation.vue";
export default {
  name: "Intro",
  data() {
    return {
      title: "Introduction",
    };
  },
  components: {
    CounterItem, CounterItemAnimation
  },
   inject: ['content'],
};
</script>
